import TextExtractionActivity from "../text/extractionActivity";
import React, { useState } from "react";
import app from "nystem";
import { Wrapper } from "nystem-components";

const ViewButtonCreateExtraction = ({ view, model }) => {
  const [state, setState] = useState("default");
  const [error, setError] = useState("");

  const config = app.settings.extraction;
  const catalog = config ? Object.entries(config.providers || {}).flatMap(([provider, entry]: [string, any]) =>
    entry.enabled === false ? [] : Object.entries(entry.models || {}).map(([id, options]: [string, any]) => ({
      provider, model: id, label: options.label || id, enabled: options.enabled,
      default: config.default?.provider === provider && config.default?.model === id,
    })),
  ) : app.settings.extractionModels || [];
  const choices = catalog.filter(
    (choice) => ["codex", "openai", "gemini"].includes(choice.provider) && choice.model && choice.enabled !== false,
  );
  const providers = { codex: "Codex", openai: "OpenAI API", gemini: "Google Gemini" };

  const createExtraction = async (choice) => {
    if (state === "saving" || !view.value?._id) return;
    setState("saving");
    setError("");

    const uploadId = view.value._id;
    try {
      const { data, error: saveError } = await app.database.result.save({
        data: {
          _id: app.uuid(),
          name: view.value.name || uploadId,
          sourceUpload: uploadId,
          sourceFilename: view.value.name,
          sourceKey: `${uploadId}:${Date.now()}`,
          ...(choice ? { provider: choice.provider, model: choice.model } : {}),
          version: 1,
          reviewStatus: "unreviewed",
          status: "queued",
          progress: 0,
        },
      });

      if (saveError || !data?._id) {
        setError(saveError?.message || saveError || "Could not create extraction.");
        setState("default");
        return;
      }

      window.history.pushState({}, "", `/result/view/${data._id}`);
    } catch (error) {
      setError(error?.message || "Could not create extraction.");
      setState("default");
    }
  };

  if (model.activityOnly) return <TextExtractionActivity view={view} />;

  return (
    <Wrapper className={model.className}>
      <select
        aria-label={model.text || "Extract data"}
        className="cursor-pointer rounded-md border border-blue-700 bg-blue-600 px-3 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-wait disabled:opacity-60"
        value=""
        disabled={state === "saving" || !view.value?._id}
        onChange={(event) => createExtraction(event.target.value === "default" ? undefined : choices[Number(event.target.value)])}
      >
        <option value="" disabled>{state === "saving" ? "Starting extraction …" : model.text || "Extract data"}</option>
        {!choices.length && <option value="default">Configured default model</option>}
        {Object.entries(providers).map(([provider, label]) => {
          const providerChoices = choices.filter((choice) => choice.provider === provider);
          if (!providerChoices.length) return null;
          return (
            <optgroup key={provider} label={config?.providers?.[provider]?.label || label}>
              {providerChoices.map((choice) => (
                <option key={choice.model} value={choices.indexOf(choice)}>
                  {choice.label || choice.model}{choice.default ? " (default)" : ""}
                </option>
              ))}
            </optgroup>
          );
        })}
      </select>
      {error && <Wrapper className="mt-1 text-sm text-red-600">{String(error)}</Wrapper>}
    </Wrapper>
  );
};

export default ViewButtonCreateExtraction;
